import React, { useMemo } from 'react';
import { ProductProperties } from '@yme/atoms/product-properties/ProductProperties';
import { COLOR_NAME_KEY, CONTROL_METHOD_KEY, ROTATION_KEY, SHAFT_LENGTH_KEY, SIZE_KEY, STARTING_METHOD_KEY, } from '@yme/common/selectors';
import { getAttributesByNames } from '@yme/utils/common';
export const useProductProperties = (attributes, labels, hasPadding = true) => {
    const properties = getAttributesByNames(attributes, [
        CONTROL_METHOD_KEY,
        STARTING_METHOD_KEY,
        SHAFT_LENGTH_KEY,
        ROTATION_KEY,
        COLOR_NAME_KEY,
        SIZE_KEY,
    ], labels);
    const hasAttributes = Boolean(Object.values(properties).length);
    const ProductPropertiesInstance = useMemo(() => {
        function getProductPropertiesInstance() {
            return (React.createElement(ProductProperties, { properties: properties, hasPadding: hasPadding }));
        }
        return getProductPropertiesInstance;
    }, [properties, hasPadding]);
    return {
        ProductProperties: ProductPropertiesInstance,
        hasAttributes,
    };
};
